import { createApi } from '@aevue/components'
import { isNative, getMobileApiUrl } from './platform.js'

export const BASE_URL = (() => {
  const mobileApiUrl = getMobileApiUrl()
  if (isNative() && mobileApiUrl) {
    return mobileApiUrl
  }

  const currentOrigin = window.location.origin
  if (currentOrigin.includes('localhost') && import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }

  return currentOrigin
})()

export const api = createApi(BASE_URL)

// Scarica tutti i dati sincronizzabili (specifico poderi2)
export async function fetchAllData() {
  return await api.get('/api/v2/poderi2/all_data')
}
